import React, {useState} from 'react'
import useDealers from '../hooks/useDealers'
import useImporters from '../hooks/useImporters'
import DealersLoading from './components/DealersLoading'
import DealersLoop from './components/DealersLoop'
import CountrySelector from '../components/CountrySelector'
import Search from '../components/Search'
import useSearch from '../hooks/useSearch'
import findClosestMarkers from '../utils/findClosestMarkers'
import useCountryStore from '../stores/useCountryStore'
import useSearchStore from '../stores/useSearchStore'

const DealersList = ({title, searchPlaceholder, selectPlaceholder, language, noCountryText, noDealersText}) => {
    const {selectedCountry} = useCountryStore()
    const {dealers, dealersLoading, dealersError} = useDealers(selectedCountry, '')
    const {importers, importersLoading, importersError} = useImporters(selectedCountry, '')
    const isLoading = dealersLoading || importersLoading

    if (dealersError || importersError) return null

    return (
        <>
            <div className='mtt-dealers__title-wrap'>
                <h2>{title}</h2>
                <div className='mtt-dealers__inputs'>
                    <CountrySelector selectPlaceholder={selectPlaceholder} language={language}/>
                    <Search searchPlaceholder={searchPlaceholder} disabled={!selectedCountry}/>
                </div>
            </div>
            <div className='mtt-dealers__grid'>
                {
                    isLoading
                        ? <DealersLoading/>
                        : <DealersLoop
                            dealers={dealers}
                            importers={importers}
                            noDealersText={noDealersText}
                            noCountryText={noCountryText}
                        />
                }
            </div>
        </>
    )
}

export default DealersList
